import { render } from "./LoginComponent.vue?vue&type=template&id=8b5f8ee8&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=8b5f8ee8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8b5f8ee8"

export default script